module.exports = __webpack_public_path__ + "img/丽江入口.68bdf6c5.jpg";